// extracted by mini-css-extract-plugin
module.exports = {"check":"check___3LSmw"};